import React, { useState } from "react";
import styled from "styled-components";
import Input from "sushiweb/InputTypes/Input";
import variables from "../../../constants/assets/variables";
import Button from "sushiweb/Button";
import { FlexContainer } from "../../../constants/assets/containers";

const InputBar = (props) => {
  const { handleDriverIdChange, title, id } = props;
  const [activeId, setActiveId] = useState("");

  const handleChange = (e) => {
    setActiveId(e);
  };
  return (
    <InputBarContainer align="flex-start">
      <Input
        borderColor={variables.primaryColor}
        id="sushi-input"
        data-testid={id}
        fullWidth={true}
        onChange={(e) => handleChange(e)}
        value={activeId}
        label={title}
      />
      <Button
        data-testid="submitButton"
        onClick={() => handleDriverIdChange(activeId)}
        disabled={!activeId}
        className="sushi-btn"
      >
        Apply
      </Button>
    </InputBarContainer>
  );
};

const InputBarContainer = styled(FlexContainer)`
  max-width: 350px;
  margin-right: 0;
  margin-bottom: 20px;
  margin-left: auto;
  #sushi-input {
    margin-bottom: unset;
    margin-right: 10px;
    & > div {
      display: none;
    }
  }
`;

export default InputBar;
